/*
 * @Author: liu yang and zhan linsen
 * @Date: 2020-02-12 13:13:57
 * @LastEditTime : 2020-03-27 15:07:14
 * @LastEditors  : Please set LastEditors
 * @Description: cookie函数，post请求，get请求
 * @FilePath: \uat\src\utils\util.js
 */

import axios from 'axios'
import config from './config'
const baseImg = 'https://premiumapi.eastmoney.com/app/api'
// const qs = require("qs")

const hostUrl = config.hostApi
const CancelToken = axios.CancelToken
let cancel = null
/**
 * 读cookie
 * @param {string} cname cookie名
 */
export function getCookie (name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ( (arr = document.cookie.match(reg))) return unescape(arr[2])
  else return null
}
/**
 * 写cookie
 * @param {string} cname cookie名
 * @param {string} cvalue cookie值
 * @param {number} exdays cookie过期时间
 */
export function setCookie (c_name, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    c_name +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
}

/**
 * 删除cookie
 * @param {string} cname cookie名
 */
export function delCookie (name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null)
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
}
/**
 * 函数节流
 * @param {function} func 需要节流的函数
 * @param {number} delay 时间，毫秒
 */
export function throttle(func, delay) {
    var prev = Date.now();
    return function() {
        var now = Date.now();
        var self = this;
        if (now - prev >= delay) {
            func.apply(self);
            prev = Date.now()
        }
    }
}
export default {
  /**
   * 封装get
   * @param {string} url 接口地址
   * @param {object} params 参数
   * @param {string} baseUrl 接口baseUrl
   */
  fetchGet(url, params = {} , baseUrl) {
    return new Promise((resolve, reject) => {
      axios
        .get(host + url, {
          params: params
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 封装get（原轮播图片使用）
   * @param {string} url 接口地址
   * @param {object} params 参数
   * @param {string} baseUrl 接口baseUrl
   */
  GetImg(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(baseImg + url, {
          params: params
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 封装post
   * @param {string} url 接口地址
   * @param {object} params 参数
   */
  Post(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(hostUrl + url, params, {
          cancelToken: new CancelToken((c) => {

            cancel = c
          // console.log(cancel)
          })
        })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 取消未完成请求
   */
  cancelRequest: function() {
    console.log(1, cancel);
    typeof cancel === "function" && cancel("cancel");
  }
}
